import {
    createStore
} from 'vuex';
export default createStore({
    state: {
        isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
    },
    mutations: {
        login(state) {
            state.isAuthenticated = true;
            localStorage.setItem('isAuthenticated', 'true'); // 存储登录状态
        },
        setUserInfo(state, info) {
            state.userInfo = info;
            localStorage.setItem('userInfo', JSON.stringify(info));
        },
        clearState(state) {
            state.isAuthenticated = false;
            localStorage.removeItem('isAuthenticated'); // 移除登录状态
            state.userInfo = null;
            localStorage.clear();
        },
    },
    actions: {
        login({
            commit
        }) {
            commit('login');
        },
        logout({
            commit
        }) {
            commit('clearState')
        },
        setUserInfo({
            commit
        }, userInfo) {
            commit('setUserInfo', userInfo); // 设置用户信息
        }
    },
});